import { create } from "zustand";

type AutoReloadLocksStore = {
  acquireLock: (lockId: string) => void;
  locks: string[];
  releaseLock: (lockId: string) => void;
};

export const useAutoReloadLocksStore = create<AutoReloadLocksStore>()((set) => ({
  acquireLock: (lockId) => {
    set((state) => (state.locks.includes(lockId) ? state : { locks: [...state.locks, lockId] }));
  },
  locks: [],
  releaseLock: (lockId) => {
    set((state) => ({ locks: state.locks.filter((currentLockId) => currentLockId !== lockId) }));
  },
}));
